module.exports = __webpack_public_path__ + "img/consultation_btn02.cb148e77.jpg";